import { nextBelow, type RngState } from './rng';
import { t } from '../i18n';

function swap<T>(arr: T[], i: number, j: number): void {
  const a = arr[i];
  const b = arr[j];
  // noUncheckedIndexedAccess 打开了，这里显式确认一下；越界说明调用方算错了
  if (a === undefined || b === undefined) {
    throw new RangeError(t('core.shuffle.indexOutOfRange', { i, j, len: arr.length }));
  }
  arr[i] = b;
  arr[j] = a;
}

/**
 * Fisher–Yates 洗牌（从后往前）。
 *
 * **确定性**：同一个 `rng` 状态必然给出同一个排列 —— 这是棋谱模型的一部分。
 *
 * ⚠️ 不要换成 `sort(() => rng() - 0.5)` 那种写法：它既不确定也不均匀。
 */
export function shuffle<T>(
  items: readonly T[],
  rng: RngState,
): { readonly items: readonly T[]; readonly rng: RngState } {
  const out = [...items];
  let cursor = rng;

  for (let i = out.length - 1; i > 0; i--) {
    const step = nextBelow(cursor, i + 1);
    cursor = step.state;
    swap(out, i, step.value);
  }

  return { items: out, rng: cursor };
}
